module.exports = __webpack_public_path__ + "img/materials.b934635e.jpg";